import type { ReactNode } from "react";
import { cx } from "./cx";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Empty state — the breathing register (space.9–13), Gabarito display title, mint icon tile. */
export function EmptyState({ icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div className={cx("pz-empty", className)}>
      {icon != null && <div className="pz-empty__icon">{icon}</div>}
      <h2 className="pz-empty__title">{title}</h2>
      {body != null && <p className="pz-empty__body">{body}</p>}
      {action != null && <div className="pz-empty__action">{action}</div>}
    </div>
  );
}
